// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonTabMedium = 36;
var ButtonMedium = 36;
var DatePickerDateCellMedium = 36;
var FieldMedium = 36;
var SizeSemanticsAll = {
  ButtonMedium: ButtonMedium,
  ButtonTabMedium: ButtonTabMedium,
  DatePickerDateCellMedium: DatePickerDateCellMedium,
  FieldMedium: FieldMedium
};

export { ButtonMedium, ButtonTabMedium, DatePickerDateCellMedium, FieldMedium, SizeSemanticsAll, SizeSemanticsAll as default };
